import { render, staticRenderFns } from "./UnInvoiceFreight.vue?vue&type=template&id=7e6f3048&"
import script from "./UnInvoiceFreight.vue?vue&type=script&lang=js&"
export * from "./UnInvoiceFreight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports